import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/stars.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm stars [<user>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/stars.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`If you have starred a lot of neat things and want to find them again
quickly this command lets you do just that.`}</p>
    <p>{`You may also want to see your friend's favorite packages, in this case
you will most certainly enjoy this command.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-star"
        }}>{`npm star`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-unstar"
        }}>{`npm unstar`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-view"
        }}>{`npm view`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-whoami"
        }}>{`npm whoami`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-adduser"
        }}>{`npm adduser`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      